import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import commonFn from './tools/commonFn'


var app = createApp(App);

// 全局函数
for (const key in commonFn) {
  if (Object.hasOwnProperty.call(commonFn, key)) {
    const fn = commonFn[key];
    app.config.globalProperties['$' + key] = fn;
  }
}

// 公园信息
const result = await P_getParkDetail({
  park_id: commonFn.ParkId,
});
if (result.success) {
  app.config.globalProperties.$parkData = result.data;
}

// 全局指令
app.directive('mouseRing', {  // 鼠标圈圈样式
  mounted(el) {
    var disableDom = ['swiper_slider_active', 'swiper-slide-thumb-active'];  // 包含这些类名的不使用圈圈，比如已经展开的轮播图应去掉圈圈样式
    el.addEventListener('mouseenter', function () {
      var mouseFollow = $(".mouse_pic");
      for (let i = 0; i < disableDom.length; i++) {
        if ($(el).hasClass(disableDom[i])) {
          return;
        }
      }
      mouseFollow.addClass("mouse_pic_light");
    });
    el.addEventListener('mouseleave', function () {
      var mouseFollow = $(".mouse_pic");
      mouseFollow.removeClass("mouse_pic_light");
    });
    el.addEventListener('click', function () {
      var mouseFollow = $(".mouse_pic");
      setTimeout(() => {
        for (let i = 0; i < disableDom.length; i++) {
          if ($(this).hasClass(disableDom[i])) {
            mouseFollow.removeClass("mouse_pic_light");
            return;
          }
        }
      }, 0)
    });
  }
});


router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {//判断是否有标题
    document.title = to.meta.title + '_' + commonFn.parkName
  } else {
    document.title = commonFn.parkName
  }
  next()  //执行进入路由，如果不写就不会进入目标页
})
app.use(router).mount('#app')
